<template>
  <el-dialog
    title="出房收款计划"
    :visible.sync="dialogVisible"
    width="88%"
    :close-on-click-modal="false"
    @close="handleClose"
    class="cf-plan-dialog"
    top="3vh"
  >
    <div class="plan-dialog-content">
      <!-- ====== 第一部分：出房信息 ====== -->
      <div class="section-part part-one">
        <el-form :model="planForm" size="small" label-width="140px">
          <el-row :gutter="20">
            <!-- 第一行：是否生成出房收款计划 -->
            <el-col :span="24">
              <div class="status-row">
                <span class="status-label">是否生成出房收款计划：</span>
                <el-tag
                  :type="hasPlan ? 'success' : 'danger'"
                  size="medium"
                  effect="dark"
                  class="status-tag"
                >
               
                  {{ hasPlan ? '是' : '否' }}
                </el-tag>
              </div>
            </el-col>

            <!-- 第二行：合同起始日 + 合同到期日 -->
            <el-col :span="12">
              <el-form-item label="合同起始日" label-width="100px">
                <el-date-picker
                  v-model="planForm.合同起始日"
                  type="date"
                  placeholder="请选择合同起始日"
                  value-format="timestamp"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同到期日" label-width="100px">
                <el-date-picker
                  v-model="planForm.合同到期日"
                  type="date"
                  placeholder="请选择合同到期日"
                  value-format="timestamp"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>

            <!-- 第三行：出房押金 + 出房租金 + 租金支付周期 -->
            <el-col :span="8">
              <el-form-item label="出房押金（元）" label-width="120px">
                <el-input-number
                  v-model="planForm.出房押金"
                  :min="0"
                  :precision="2"
                  :step="100"
                  placeholder="请输入出房押金"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出房租金（元/月）" label-width="140px">
                <el-input-number
                  v-model="planForm.出房租金"
                  :min="0"
                  :precision="2"
                  :step="100"
                  placeholder="请输入租金"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租金支付周期" label-width="120px">
                <el-select
                  v-model="planForm.租金支付周期"
                  placeholder="请选择支付周期"
                  style="width:100%"
                  :disabled="hasPlan"
                >
                  <el-option label="按月" value="按月" />
                  <el-option label="按季" value="按季" />
                  <el-option label="按半年" value="按半年" />
                  <el-option label="按年" value="按年" />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 第四行：物业/宽带费 + 水电气押金 + 物业宽带费支付周期 -->
            <el-col :span="8">
              <el-form-item label="物业/宽带费（元/月）" label-width="150px">
                <el-input-number
                  v-model="planForm.物业宽带费"
                  :min="0"
                  :precision="2"
                  :step="50"
                  placeholder="请输入物业/宽带费"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="水电气押金（元）" label-width="130px">
                <el-input-number
                  v-model="planForm.水电气押金"
                  :min="0"
                  :precision="2"
                  :step="100"
                  placeholder="请输入水电气押金"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物业宽带费支付周期" label-width="150px">
                <el-select
                  v-model="planForm.物业宽带费支付周期"
                  placeholder="请选择支付周期"
                  style="width:100%"
                  :disabled="hasPlan"
                >
                  <el-option label="按季" value="按季" />
                  <el-option label="按年" value="按年" />
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 第五行：定金金额 + 宠物押金 -->
            <el-col :span="12">
              <el-form-item label="定金金额（元）" label-width="120px">
                <el-input-number
                  v-model="planForm.定金金额"
                  :min="0"
                  :precision="2"
                  :step="100"
                  placeholder="请输入定金金额"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="宠物押金（元）" label-width="120px">
                <el-input-number
                  v-model="planForm.宠物押金"
                  :min="0"
                  :precision="2"
                  :step="100"
                  placeholder="请输入宠物押金"
                  style="width:100%"
                  :disabled="hasPlan"
                />
              </el-form-item>
            </el-col>

            <!-- 第六行：按钮（右对齐） -->
            <el-col :span="24">
              <div class="button-row">
                <el-button
                  type="primary"
                  :disabled="hasPlan"
                  @click="handleGenerate"
                  :loading="generating"
                >
                  生成
                </el-button>
                <el-button
                  type="warning"
                  :disabled="!canRegenerate"
                  @click="handleRegenerate"
                >
                  重新生成
                </el-button>
                <el-button
                  type="success"
                  plain
                  @click="handleReload"
                  :loading="reloading"
                >
                  重新加载
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- ====== 第二部分：生成的临时付款计划（可编辑） ====== -->
      <div v-if="showPartTwo" class="section-part part-two">
        <div class="section-title">生成的付款计划（请核对并修改）</div>
        <div class="temp-table-wrapper">
          <el-table :data="tempPlanList" border stripe size="small">
            <el-table-column label="第几次收款" width="120" align="center">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.第几次付款"
                  :min="1"
                  :step="1"
                  size="small"
                  controls-position="right"
                  style="width:100px"
                />
              </template>
            </el-table-column>
            <el-table-column label="收款日期" width="180" align="center">
              <template slot-scope="{ row }">
                <el-date-picker
                  v-model="row.付款时间"
                  type="date"
                  placeholder="请选择日期"
                  value-format="timestamp"
                  size="small"
                  style="width:160px"
                />
              </template>
            </el-table-column>
            <el-table-column label="收款金额" width="150" align="center">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.付款金额"
                  :min="0"
                  :precision="2"
                  :step="100"
                  size="small"
                  controls-position="right"
                  style="width:130px"
                />
              </template>
            </el-table-column>
            <el-table-column label="资金说明" min-width="200">
              <template slot-scope="{ row }">
                <el-input v-model="row.资金说明" size="small" placeholder="请输入资金说明" />
              </template>
            </el-table-column>
            <el-table-column label="状态" width="120" align="center">
              <template slot-scope="{ row }">
                <el-tag type="info" size="small">待收</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="150">
              <template slot-scope="{ row }">
                <el-input v-model="row.备注" size="small" placeholder="请输入备注" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="temp-save-row">
          <el-button
            type="primary"
            @click="handleSaveTempPlan"
            :loading="saving"
            :disabled="tempPlanList.length === 0"
          >
            保存
          </el-button>
        </div>
      </div>

      <!-- ====== 第三部分：已保存的付款计划表格 ====== -->
      <div v-if="showPartThree" class="section-part part-three">
        <div class="section-header">
          <span class="section-title">已生成的付款计划</span>
          <div class="section-actions">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">
              新增
            </el-button>
          </div>
        </div>
        <el-table
          :data="savedPlanList"
          border
          stripe
          v-loading="tableLoading"
          size="small"
          :default-sort="{ prop: '第几次付款', order: 'ascending' }"
        >
          <el-table-column prop="第几次付款" label="第几次收款" width="120" align="center" sortable />
          <el-table-column prop="付款时间" label="收款日期" width="180" align="center">
            <template slot-scope="{ row }">
              {{ formatTimestamp(row.付款时间) }}
            </template>
          </el-table-column>
          <el-table-column prop="付款金额" label="收款金额" width="150" align="right">
            <template slot-scope="{ row }">
              ¥{{ (row.付款金额 || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="资金说明" label="资金说明" min-width="200" show-overflow-tooltip />
          <el-table-column prop="状态" label="状态" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="getStatusType(row.状态)" size="small">
                {{ row.状态 || '-' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="备注" label="备注" min-width="150" show-overflow-tooltip />
          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="mini"
                @click="openEditDialog(row)"
                :disabled="!canModify(row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="mini"
                style="color: #f56c6c;"
                @click="handleDelete(row)"
                :disabled="!canModify(row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="savedPlanList.length === 0" class="empty-tip">
          暂无付款计划数据
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>

    <!-- ====== 新增弹窗 ====== -->
    <el-dialog
      title="新增收款计划"
      :visible.sync="addDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetAddForm"
    >
      <el-form :model="addForm" label-width="120px" size="small">
        <el-form-item label="房屋地址">
          <el-input v-model="addForm.房屋地址" disabled />
        </el-form-item>
        <el-form-item label="第几次收款" required>
          <el-input-number
            v-model="addForm.第几次付款"
            :min="1"
            :step="1"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="收款日期" required>
          <el-date-picker
            v-model="addForm.付款时间"
            type="date"
            placeholder="请选择收款日期"
            value-format="timestamp"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="收款金额" required>
          <el-input-number
            v-model="addForm.付款金额"
            :min="0"
            :precision="2"
            :step="100"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="资金说明" required>
          <el-input v-model="addForm.资金说明" placeholder="请输入资金说明" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.备注" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleAddSubmit" :loading="addDialog.submitting">
          确认
        </el-button>
      </span>
    </el-dialog>

    <!-- ====== 修改弹窗 ====== -->
    <el-dialog
      title="修改收款计划"
      :visible.sync="editDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetEditForm"
    >
      <el-form :model="editForm" label-width="120px" size="small">
        <el-form-item label="第几次收款" required>
          <el-input-number
            v-model="editForm.第几次付款"
            :min="1"
            :step="1"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="收款日期" required>
          <el-date-picker
            v-model="editForm.付款时间"
            type="date"
            placeholder="请选择收款日期"
            value-format="timestamp"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="收款金额" required>
          <el-input-number
            v-model="editForm.付款金额"
            :min="0"
            :precision="2"
            :step="100"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="资金说明" required>
          <el-input v-model="editForm.资金说明" placeholder="请输入资金说明" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editForm.备注" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleEditSubmit" :loading="editDialog.submitting">
          确认
        </el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>


<script>
import { cfPlanApi } from '@/api/付款/cfPlanApi'

export default {
  name: 'CfPlanDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      generating: false,
      saving: false,
      reloading: false,
      tableLoading: false,

      // ====== 计划表单 ======
      planForm: {
        合同起始日: null,
        合同到期日: null,
        出房押金: 0,
        出房租金: null,
        租金支付周期: '按季',
        物业宽带费: 0,
        水电气押金: 0,
        物业宽带费支付周期: '按年',
        定金金额: 0,
        宠物押金: 0
      },

      // ====== 状态 ======
      hasPlan: false,
      canRegenerate: false,

      // ====== 第二部分：临时数据 ======
      tempPlanList: [],
      showPartTwo: false,

      // ====== 第三部分：已保存数据 ======
      savedPlanList: [],
      showPartThree: false,

      // ====== 房源基础数据 ======
      houseData: {},

      // ====== 新增弹窗 ======
      addDialog: {
        visible: false,
        submitting: false
      },
      addForm: {
        房屋地址: '',
        第几次付款: null,
        付款时间: null,
        付款金额: null,
        资金说明: '',
        备注: ''
      },

      // ====== 修改弹窗 ======
      editDialog: {
        visible: false,
        submitting: false,
        editId: null
      },
      editForm: {
        第几次付款: null,
        付款时间: null,
        付款金额: null,
        资金说明: '',
        备注: ''
      }
    }
  },

  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.rowData) {
        this.initData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },

  methods: {
    // ====== 初始化数据 ======
    initData() {
      const data = this.rowData
      if (!data) return

      this.houseData = { ...data }

      this.planForm = {
        合同起始日: data.合同起始日 || null,
        合同到期日: data.合同到期日 || null,
        出房押金: data['出房押金（元）'] || 0,
        出房租金: data['出房租金（元/月）'] || null,
        租金支付周期: data.租金支付周期 || '按季',
        物业宽带费: data.物业费 || 0,
        水电气押金: data.水电气押金 || 0,
        物业宽带费支付周期: data['物业/宽带费支付周期'] || '按年',
        定金金额: data.定金金额 || 0,
        宠物押金: data.宠物押金 || 0
      }

      this.tempPlanList = []
      this.savedPlanList = []
      this.showPartTwo = false
      this.showPartThree = false

      this.handleReload()
    },

    // ====== 重新加载 ======
    handleReload() {
      this.reloading = true
      this.checkPlan()
    },

  // ====== 检查是否生成过计划 ======
async checkPlan() {
  if (!this.houseData.id) {
    this.reloading = false
    return
  }

  try {
    const params = {
      出房ID: String(this.houseData.id)
    }

    console.log('检查出房计划参数===', params)

    const res = await cfPlanApi.selectPlan(params)
    console.log('检查出房计划返回===', res)

    if (res.code === 200) {
      // 过滤掉状态为"已作废"的数据
      const allList = res.data?.list || []
      const validList = allList.filter(item => item.状态 !== '已作废')
      
      this.hasPlan = validList.length > 0

      if (this.hasPlan) {
        this.savedPlanList = validList.map(item => this.mapFields(item))
        this.showPartThree = true
        this.showPartTwo = false

        // 检查是否可以重新生成：所有记录状态必须为"待收"
        const allPending = this.savedPlanList.every(item => item.状态 === '待收')
        this.canRegenerate = allPending
      } else {
        this.savedPlanList = []
        this.showPartThree = false
        this.showPartTwo = true
        this.canRegenerate = false
      }
    } else {
      this.$message.error(res.message || '检查计划失败')
    }
  } catch (error) {
    console.error('检查计划失败:', error)
    this.$message.error(error.message || '检查计划失败，请稍后重试')
  } finally {
    this.reloading = false
  }
},

    // ====== 字段映射（后端 -> 前端） ======
    mapFields(data) {
      const map = {
        'id': 'id',
        '出房ID': '出房ID',
        '状态': '状态',
        '付款时间': '付款时间',
        '付款金额': '付款金额',
        '房屋地址': '房屋地址',
        '第几次付款': '第几次付款',
        '资金说明': '资金说明',
        '备注': '备注',
        '租客姓名': '租客姓名',
        '出房人': '出房人',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '已收': '已收',
        '未收': '未收',
        '实际收款金额': '实际收款金额'
      }

      const result = {}
      for (const [key, val] of Object.entries(map)) {
        if (data[key] !== undefined && data[key] !== null) {
          result[val] = data[key]
        }
      }

      // 时间戳转为毫秒级
      const timestampFields = ['付款时间', '合同起始日', '合同到期日']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null) {
          const str = String(result[field])
          if (str.length === 10) {
            result[field] = result[field] * 1000
          }
        }
      })

      return result
    },

    // ====== 字段映射（前端 -> 后端） ======
    mapToBackend(data) {
      const map = {
        '出房ID': '出房ID',
        '状态': '状态',
        '付款时间': '付款时间',
        '付款金额': '付款金额',
        '房屋地址': '房屋地址',
        '第几次付款': '第几次付款',
        '租客姓名': '租客姓名',
        '出房人': '出房人',
        '资金说明': '资金说明',
        '备注': '备注',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日'
      }

      const result = {}
      for (const [key, val] of Object.entries(map)) {
        if (data[key] !== undefined && data[key] !== null) {
          result[val] = data[key]
        }
      }

      // 时间戳转为秒级
      const timestampFields = ['付款时间', '合同起始日', '合同到期日']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null) {
          const str = String(result[field])
          if (str.length === 13) {
            result[field] = Math.floor(result[field] / 1000)
          }
        }
      })

      return result
    },

    // ====== 计算支付周期月数 ======
    getPeriodMonths(period) {
      const map = {
        '按月': 1,
        '按季': 3,
        '按半年': 6,
        '按年': 12
      }
      return map[period] || 3
    },

    // ====== 生成付款计划 ======
    handleGenerate() {
      const form = this.planForm

      // 验证必填字段
      if (!form.合同起始日) {
        this.$message.warning('请选择合同起始日')
        return
      }
      if (!form.合同到期日) {
        this.$message.warning('请选择合同到期日')
        return
      }
      if (!form.出房租金 || form.出房租金 <= 0) {
        this.$message.warning('请输入有效的出房租金')
        return
      }
      if (!form.租金支付周期) {
        this.$message.warning('请选择租金支付周期')
        return
      }
      if (!form.物业宽带费支付周期) {
        this.$message.warning('请选择物业宽带费支付周期')
        return
      }

      // 检查租客姓名和出房人
      if (!this.houseData.租客姓名) {
        this.$message.warning('当前出房记录缺少租客姓名，请先补充')
        return
      }
      if (!this.houseData.出房人) {
        this.$message.warning('当前出房记录缺少出房人，请先补充')
        return
      }

      this.generating = true

      try {
        const planList = this.calculatePlan(form)
        this.tempPlanList = planList
        this.showPartTwo = true
        this.showPartThree = false

        this.$message.success(`成功生成 ${planList.length} 条付款计划`)
      } catch (error) {
        console.error('生成失败:', error)
        this.$message.error(error.message || '生成失败')
      } finally {
        this.generating = false
      }
    },

    // ====== 计算付款计划算法 ======
    calculatePlan(form) {
      const {
        合同起始日,
        合同到期日,
        出房押金,
        出房租金,
        租金支付周期,
        物业宽带费,
        水电气押金,
        物业宽带费支付周期,
        宠物押金
      } = form

      const rentMonths = this.getPeriodMonths(租金支付周期)
      const propertyMonths = this.getPeriodMonths(物业宽带费支付周期)

      const startDate = new Date(合同起始日)
      const endDate = new Date(合同到期日)

      // 计算每期金额
      const rentAmount = 出房租金 * rentMonths
      const propertyAmount = 物业宽带费 * propertyMonths

      // 首次付款日期 = 合同起始日 + 1天
      const firstDate = new Date(startDate)
      firstDate.setDate(firstDate.getDate() + 1)

      const planList = []
      let count = 1
      let currentDate = new Date(firstDate)
      let lastPropertyPaymentDate = null

      // 第一次付款：租金*周期 + 物业费*周期 + 水电气押金 + 宠物押金
      let firstAmount = rentAmount + propertyAmount + (水电气押金 || 0) + (宠物押金 || 0)

      // 生成资金说明
      let fundDesc = `出房租金(${出房租金})*${rentMonths}`
      if (物业宽带费 > 0) {
        fundDesc += `+物业宽带费(${物业宽带费})*${propertyMonths}`
      }
      if (水电气押金 > 0) {
        fundDesc += `+水电气押金`
      }
      if (宠物押金 > 0) {
        fundDesc += `+宠物押金`
      }

      planList.push({
        第几次付款: count,
        付款时间: new Date(firstDate).getTime(),
        付款金额: firstAmount,
        资金说明: fundDesc,
        状态: '待收',
        备注: ''
      })

      lastPropertyPaymentDate = new Date(firstDate)
      count = 2

      // 后续付款日期 = 上次付款日期 + rentMonths 个月
      let nextDate = new Date(firstDate)
      nextDate.setMonth(nextDate.getMonth() + rentMonths)

      while (nextDate <= endDate) {
        let amount = rentAmount
        let desc = `出房租金(${出房租金})*${rentMonths}`

        // 检查是否需要支付物业宽带费
        const needProperty = (lastPropertyPaymentDate === null) ||
          (this.diffMonths(lastPropertyPaymentDate, nextDate) >= propertyMonths)

        if (needProperty && 物业宽带费 > 0) {
          amount += propertyAmount
          desc += `+物业宽带费(${物业宽带费})*${propertyMonths}`
          lastPropertyPaymentDate = new Date(nextDate)
        }

        // 检查是否超过合同到期日（最后一期）
        const nextNextDate = new Date(nextDate)
        nextNextDate.setMonth(nextNextDate.getMonth() + rentMonths)

        if (nextNextDate > endDate) {
          // 最后一期：计算剩余天数
          const diffDays = this.diffDays(nextDate, endDate)
          const dailyRent = 出房租金 / 30
          const dailyProperty = 物业宽带费 / 30
          const remainingAmount = (dailyRent + dailyProperty) * diffDays

          // 取整保留两位小数
          amount = Math.round(remainingAmount * 100) / 100
          desc = `(出房租金${出房租金}+物业宽带费${物业宽带费})/30*剩余天数(${diffDays})`
        }

        planList.push({
          第几次付款: count,
          付款时间: new Date(nextDate).getTime(),
          付款金额: amount,
          资金说明: desc,
          状态: '待收',
          备注: ''
        })

        nextDate.setMonth(nextDate.getMonth() + rentMonths)
        count++
      }

      return planList
    },

    // ====== 计算两个日期之间的月数差 ======
    diffMonths(date1, date2) {
      const d1 = new Date(date1)
      const d2 = new Date(date2)
      return (d2.getFullYear() - d1.getFullYear()) * 12 + (d2.getMonth() - d1.getMonth())
    },

    // ====== 计算两个日期之间的天数差（包含结束日期） ======
    diffDays(startDate, endDate) {
      const start = new Date(startDate)
      const end = new Date(endDate)
      const diffTime = end.getTime() - start.getTime()
      return Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1
    },

    // ====== 保存临时计划（批量插入） ======
    async handleSaveTempPlan() {
      if (this.tempPlanList.length === 0) {
        this.$message.warning('没有可保存的数据')
        return
      }

      // 验证必填字段
      for (let i = 0; i < this.tempPlanList.length; i++) {
        const item = this.tempPlanList[i]
        if (!item.付款时间) {
          this.$message.warning(`第 ${i + 1} 条记录缺少收款日期`)
          return
        }
        if (!item.付款金额 || item.付款金额 <= 0) {
          this.$message.warning(`第 ${i + 1} 条记录收款金额无效`)
          return
        }
        if (!item.资金说明) {
          this.$message.warning(`第 ${i + 1} 条记录缺少资金说明`)
          return
        }
      }

      try {
        await this.$confirm(
          `确认保存 ${this.tempPlanList.length} 条付款计划吗？`,
          '提示',
          {
            type: 'warning',
            confirmButtonText: '确认保存',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      this.saving = true

      try {
        const dataList = this.tempPlanList.map(item => {
          const backendData = this.mapToBackend({
            出房ID: String(this.houseData.id),
            状态: '待收',
            付款时间: item.付款时间,
            付款金额: Math.round(item.付款金额 * 100) / 100,
            房屋地址: this.houseData.房屋地址 || '',
            第几次付款: item.第几次付款,
            租客姓名: this.houseData.租客姓名 || '',
            出房人: this.houseData.出房人 || '',
            资金说明: item.资金说明,
            备注: item.备注 || '',
            合同起始日: this.planForm.合同起始日,
            合同到期日: this.planForm.合同到期日
          })
          return backendData
        })

        const params = { dataList }
        console.log('批量插入参数===', params)

        const res = await cfPlanApi.insertPlanBatch(params)
        console.log('批量插入返回===', res)

        if (res.code === 200) {
          this.$message.success(`成功保存 ${dataList.length} 条付款计划`)
          this.tempPlanList = []
          this.showPartTwo = false
          await this.checkPlan()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(error.message || '保存失败，请稍后重试')
      } finally {
        this.saving = false
      }
    },

    // ====== 重新生成 ======
    async handleRegenerate() {
      // 检查是否可以重新生成
      if (this.savedPlanList.some(item => item.状态 !== '待收')) {
        this.$message.warning('已经出现非待收记录，不可重新生成，请手动修改计划')
        return
      }

      try {
        await this.$confirm(
          '请注意，重新生成会清空之前的出房收款计划，点击确认后不可撤回！',
          '重新生成提示',
          {
            type: 'warning',
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            customClass: 'regenerate-confirm'
          }
        )
      } catch {
        return
      }

      try {
        const params = { 出房ID: String(this.houseData.id) }
        console.log('批量作废参数===', params)

        const res = await cfPlanApi.invalidatePlan(params)
        console.log('批量作废返回===', res)

        if (res.code === 200) {
          this.$message.success(res.data?.message || '作废成功')
          this.hasPlan = false
          this.canRegenerate = false
          this.savedPlanList = []
          this.showPartThree = false
          this.showPartTwo = true
          this.tempPlanList = []
          await this.checkPlan()
        } else {
          this.$message.error(res.message || '作废失败')
        }
      } catch (error) {
        console.error('作废失败:', error)
        this.$message.error(error.message || '作废失败，请稍后重试')
      }
    },

    // ====== 打开新增弹窗 ======
    openAddDialog() {
      this.addForm = {
        房屋地址: this.houseData.房屋地址 || '',
        第几次付款: null,
        付款时间: null,
        付款金额: null,
        资金说明: '',
        备注: ''
      }
      this.addDialog.visible = true
    },

    // ====== 重置新增表单 ======
    resetAddForm() {
      this.addDialog.submitting = false
    },

    // ====== 新增提交 ======
    async handleAddSubmit() {
      const form = this.addForm

      if (!form.第几次付款 || form.第几次付款 < 1) {
        this.$message.warning('请输入有效的第几次付款')
        return
      }
      if (!form.付款时间) {
        this.$message.warning('请选择收款日期')
        return
      }
      if (!form.付款金额 || form.付款金额 <= 0) {
        this.$message.warning('请输入有效的收款金额')
        return
      }
      if (!form.资金说明) {
        this.$message.warning('请输入资金说明')
        return
      }

      this.addDialog.submitting = true

      try {
        const params = {
          出房ID: String(this.houseData.id),
          状态: '待收',
          付款时间: Math.floor(form.付款时间 / 1000),
          付款金额: Math.round(form.付款金额 * 100) / 100,
          房屋地址: this.houseData.房屋地址 || '',
          第几次付款: form.第几次付款,
          租客姓名: this.houseData.租客姓名 || '',
          出房人: this.houseData.出房人 || '',
          资金说明: form.资金说明,
          备注: form.备注 || '',
          合同起始日: this.planForm.合同起始日 ? Math.floor(this.planForm.合同起始日 / 1000) : null,
          合同到期日: this.planForm.合同到期日 ? Math.floor(this.planForm.合同到期日 / 1000) : null
        }

        console.log('新增参数===', params)

        const res = await cfPlanApi.insertPlan(params)
        console.log('新增返回===', res)

        if (res.code === 200) {
          this.$message.success('新增成功')
          this.addDialog.visible = false
          await this.checkPlan()
        } else {
          this.$message.error(res.message || '新增失败')
        }
      } catch (error) {
        console.error('新增失败:', error)
        this.$message.error(error.message || '新增失败，请稍后重试')
      } finally {
        this.addDialog.submitting = false
      }
    },

    // ====== 判断是否可以修改 ======
    canModify(row) {
      if (!row) return false
      const status = row.状态
      return status === '待收' || status === '部分收款'
    },

    // ====== 打开修改弹窗 ======
    openEditDialog(row) {
      if (!this.canModify(row)) {
        this.$message.warning('该记录状态不可修改')
        return
      }

      this.editDialog.editId = row.id
      this.editForm = {
        第几次付款: row.第几次付款,
        付款时间: row.付款时间,
        付款金额: row.付款金额,
        资金说明: row.资金说明 || '',
        备注: row.备注 || ''
      }
      this.editDialog.visible = true
    },

    // ====== 重置修改表单 ======
    resetEditForm() {
      this.editDialog.submitting = false
      this.editDialog.editId = null
    },

    // ====== 修改提交 ======
    async handleEditSubmit() {
      const form = this.editForm

      if (!form.第几次付款 || form.第几次付款 < 1) {
        this.$message.warning('请输入有效的第几次付款')
        return
      }
      if (!form.付款时间) {
        this.$message.warning('请选择收款日期')
        return
      }
      if (!form.付款金额 || form.付款金额 <= 0) {
        this.$message.warning('请输入有效的收款金额')
        return
      }
      if (!form.资金说明) {
        this.$message.warning('请输入资金说明')
        return
      }

      this.editDialog.submitting = true

      try {
        const params = {
          id: this.editDialog.editId,
          付款时间: Math.floor(form.付款时间 / 1000),
          付款金额: Math.round(form.付款金额 * 100) / 100,
          第几次付款: form.第几次付款,
          资金说明: form.资金说明,
          备注: form.备注 || ''
        }

        console.log('修改参数===', params)

        const res = await cfPlanApi.updatePlan(params)
        console.log('修改返回===', res)

        if (res.code === 200) {
          this.$message.success('修改成功')
          this.editDialog.visible = false
          await this.checkPlan()
        } else {
          this.$message.error(res.message || '修改失败')
        }
      } catch (error) {
        console.error('修改失败:', error)
        this.$message.error(error.message || '修改失败，请稍后重试')
      } finally {
        this.editDialog.submitting = false
      }
    },

    // ====== 删除 ======
    async handleDelete(row) {
      if (!this.canModify(row)) {
        this.$message.warning('该记录状态不可删除')
        return
      }

      try {
        await this.$confirm(
          `确认删除第 ${row.第几次付款} 次付款计划吗？删除后不可撤回！`,
          '提示',
          {
            type: 'warning',
            confirmButtonText: '确认删除',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      try {
        const params = { id: row.id }
        console.log('删除参数===', params)

        const res = await cfPlanApi.deletePlan(params)
        console.log('删除返回===', res)

        if (res.code === 200 && res.data?.deleted) {
          this.$message.success('删除成功')
          await this.checkPlan()
        } else {
          this.$message.warning(res.data?.message || '删除失败')
        }
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error.message || '删除失败，请稍后重试')
      }
    },

    // ====== 获取状态标签类型 ======
    getStatusType(status) {
      const map = {
        '待收': 'danger',
        '部分收款': 'warning',
        '已完成': 'success',
        '退回': 'info',
        '已中止': 'info',
        '待确认': 'info',
        '其他': 'info'
      }
      return map[status] || 'info'
    },

    // ====== 时间戳格式化 ======
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      let ts = timestamp
      const str = String(ts)
      if (str.length === 10) {
        ts = ts * 1000
      }
      const date = new Date(ts)
      if (isNaN(date.getTime())) {
        return '-'
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // ====== 关闭弹窗 ======
    handleClose() {
      this.dialogVisible = false
    },

    // ====== 刷新数据（外部调用） ======
    refresh() {
      this.checkPlan()
    }
  }
}
</script>

<style scoped>
.cf-plan-dialog /deep/ .el-dialog {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.cf-plan-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.cf-plan-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.cf-plan-dialog-content {
  height: 68vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

.cf-plan-dialog-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.cf-plan-dialog-content::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.cf-plan-dialog-content::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.cf-plan-dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

.cf-plan-dialog-content {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

/* ====== 第一部分 ====== */
.part-one {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.status-row {
  display: flex;
  align-items: center;
  padding: 8px 0 16px 0;
}

.status-label {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  margin-right: 12px;
}

.status-tag {
  font-size: 14px;
  /* padding: 6px 16px; */
}

.status-tag i {
  margin-right: 4px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 8px;
}

/* ====== 第二部分 ====== */
.part-two {
  padding: 0 4px;
}

.temp-table-wrapper {
  margin-bottom: 12px;
}

.temp-save-row {
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
}

/* ====== 第三部分 ====== */
.part-three {
  padding: 0 4px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 12px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.section-actions {
  display: flex;
  gap: 8px;
}

.section-part {
  margin-bottom: 16px;
}

.section-part:last-child {
  margin-bottom: 0;
}

.empty-tip {
  text-align: center;
  padding: 20px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 8px;
}

.regenerate-confirm /deep/ .el-dialog {
  border-top: 4px solid #f56c6c;
}

.regenerate-confirm /deep/ .el-dialog__title {
  color: #f56c6c;
}

@media (max-width: 768px) {
  .cf-plan-dialog /deep/ .el-dialog {
    width: 95% !important;
  }

  .cf-plan-dialog-content {
    height: 50vh;
  }

  .button-row {
    flex-wrap: wrap;
    justify-content: center;
  }

  .status-row {
    flex-wrap: wrap;
  }
}
</style>